import { render, staticRenderFns } from "./BowContentMediaSx.vue?vue&type=template&id=1e6f9d5e&"
import script from "./BowContentMediaSx.vue?vue&type=script&lang=js&"
export * from "./BowContentMediaSx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowContentMedia: require('/workspace/components/organisms/BowContentMedia/BowContentMedia.vue').default})
